if (!customElements.get('cuf-purchase-summary')) {
  customElements.define('cuf-purchase-summary', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.variants = JSON.parse(this.querySelector('script').textContent);
      this.quantity = this.productInfo.querySelector('input[name="quantity"]');
      this.form = document.getElementById(this.dataset.form);
      this.nativeAdd = this.form.querySelector('.product-form__submit');
      this.money = new Intl.NumberFormat('en-GB', {style:'currency', currency:this.dataset.currency});
      this.refresh = this.update.bind(this);
      this.syncVisibility = () => {
        const sticky = [...document.querySelectorAll('[data-cuf-form]')].find(e => e.dataset.cufForm === this.dataset.form);
        if (!sticky) return;
        const rect = this.nativeAdd.getBoundingClientRect();
        const visible = rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
        sticky.classList.toggle('is-native-add-visible', visible);
        if (visible) sticky.setAttribute('aria-hidden', 'true');
        else sticky.removeAttribute('aria-hidden');
      };
      window.addEventListener('scroll', this.syncVisibility, {passive:true});
      window.addEventListener('resize', this.syncVisibility);
      this.productInfo.addEventListener('input', this.refresh);
      this.productInfo.addEventListener('change', this.refresh);
      this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
        if (String(data.sectionId) === this.dataset.section) this.update();
      });
      this.unsubscribeQuantity = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.refresh);
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.nativeAdd, {attributes:true, attributeFilter:['disabled'], childList:true, subtree:true});
      this.update();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.syncVisibility);
      window.removeEventListener('resize', this.syncVisibility);
      this.productInfo.removeEventListener('input', this.refresh);
      this.productInfo.removeEventListener('change', this.refresh);
      this.unsubscribeVariant?.();
      this.unsubscribeQuantity?.();
      this.observer?.disconnect();
    }
    update() {
      const variant = this.variants.find(v => String(v.id) === this.form.querySelector('input[name="id"]').value);
      const quantity = Number(this.quantity.value);
      const multiplier = Number(this.dataset.multiplier);
      const label = this.productInfo.querySelector('.quantity__label > span');
      if (label) label.textContent = this.dataset.quantityLabel;
      const hiddenLabel = this.productInfo.querySelector('#quantity-label-' + this.dataset.section);
      if (hiddenLabel && !Number(this.quantity.dataset.cartQuantity)) hiddenLabel.textContent = this.dataset.quantityLabel;
      const count = multiplier === 10 ? quantity + ' ' + (quantity === 1 ? 'pack' : this.dataset.packLabel) + ' = ' + quantity * 10 + ' ' + this.dataset.chairLabel : quantity + ' ' + (quantity === 1 ? 'chair' : this.dataset.chairLabel);
      this.querySelector('[data-cuf-count]').textContent = count;
      this.querySelector('[data-cuf-total]').textContent = variant && quantity > 0 ? this.money.format(variant.price * quantity / 100) : '—';
      const unit = this.querySelector('[data-cuf-unit]');
      if (unit) unit.textContent = variant ? this.money.format(variant.price / 100 / multiplier) : '—';
      const sticky = [...document.querySelectorAll('[data-cuf-form]')].find(e => e.dataset.cufForm === this.dataset.form);
      if (!sticky) return;
      const button = sticky.querySelector('button[name="add"]');
      button.disabled = this.nativeAdd.disabled || !variant || !this.quantity.validity.valid;
      const summary = sticky.querySelector('.cuf-sticky-summary');
      if (summary) summary.textContent = variant ? (variant.title === 'Default Title' ? '' : variant.title + ' · ') + count + ' · ' + this.money.format(variant.price * quantity / 100) : '—';
      this.syncVisibility();
    }
  });
}
